export const TEST_ID = 'warningDialog';
